module.exports = __webpack_public_path__ + "static/media/help_studies_map_important.21b04c74.svg";